import React, { useEffect } from "react";
import "@mantine/core/styles.css";
import "./App.module.scss";
import ScrollToTop from "./components/scrollToTop.component";
import Header from "./components/Header/Header.component";
import styles from "./App.module.scss";
import Footer from "./components/Footer/Footer.component";
import SectionTitle from "./components/SectionTitle/SectionTitle.component";
import CookiesBanner from "./components/CookiesBanner/CookiesBanner.component";
import FtsoService from "./utils/ftso.service";
import { configureFtsoWeb3 } from "@flare.space/ftso-web3";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HomePage from "./pages/home/HomePage";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "flare-space-menu": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
    interface IntrinsicElements {
      "promo-banner": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const embed: boolean = !!urlParams.get("embed");
  useEffect(() => {
    if (!embed) {
      FtsoService.init();
    }

    if (import.meta.env.VITE_DEPLOY_TARGET === "production") {
      configureFtsoWeb3("Production");
    } else if (import.meta.env.VITE_DEPLOY_TARGET !== "production") {
      configureFtsoWeb3("Test");
    } else {
      console.error(
        "RPC node environment variable is not set correctly. Its value should either be 'production' or 'staging'"
      );
    }
  }, []);

  return (
    <div>
      <ScrollToTop />
      {!embed && <Header></Header>}
      <div className={styles.AppContent}>
        {!embed && <SectionTitle></SectionTitle>}
        <HomePage />
      </div>
      {!embed && <Footer></Footer>}
      <ToastContainer className="toast" newestOnTop pauseOnFocusLoss={false} />
      {!embed && <CookiesBanner />}
    </div>
  );
}

export default App;
